// extracted by mini-css-extract-plugin
export default {"departments":"jG-z","departmentHeading":"kG-z","departmentSection":"lG-z","departmentName":"mG-z","departmentLink":"nG-z","expandIcon":"oG-z"};